var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-banner',{attrs:{"imgSrc":_vm.imgPath,"imgLabel":_vm.imgLabel}}),_vm._v(" "),_c('common-main',{attrs:{"title":_vm.imgLabel,"menus":_vm.sideMenus},on:{"clickSideMenu":_vm.handleSideClick}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('list-page',{attrs:{"dataSource":_vm.dataSource}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b19ef04a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/productpage/ProductPage.vue
// module id = null
// module chunks = 